import styled, { css } from 'styled-components';
import { Box, TextStyled } from '@bechtel/gds';

const headerRowHeight = '90px';
const headerColumnWidth = '160px';
export const BoxCellStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  width: 150px;
`;

export const HeaderBoxStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  alignItems: { sm: 'flex-end' },
  justifyContent: { sm: 'center' },
  pr: { sm: '300' },
})`
  position: absolute;
  ${({ theme }) => css`
    border-right: 1px solid ${theme.colors.grey[300]};
    border-bottom: 1px solid ${theme.colors.grey[300]};
    height: ${headerRowHeight};
    width: ${headerColumnWidth};
    background: ${theme.colors.white};
    left: ${theme.spacings[350]};
  `}
`;
export const CrewListBoxStyled = styled(Box).attrs({
  pt: { sm: '400' },
  pl: { sm: '300' },
})`
  margin-left: ${headerColumnWidth};
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
    height: ${headerRowHeight};
  `}
`;

export const TotalColumnBoxStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  alignItems: { sm: 'flex-end' },
  justifyContent: { sm: 'center' },
  pr: { sm: '300' },
})`
  position: absolute;
  ${({ theme }) => css`
    border-right: 1px solid ${theme.colors.grey[300]};
    width: ${headerColumnWidth};
    background: ${theme.colors.white};
    left: ${theme.spacings[350]};
  `}
`;

export const TotalValueBoxStyled = styled(Box).attrs({
  pl: { sm: '500' },
  py: { sm: '400' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'flex-start' },
})`
  width: 150px;
`;

export const CommentsBoxStyled = styled(Box).attrs({
  pr: { sm: '500' },
  alignItem: { sm: 'center' },
  ml: { sm: '300' },
})<{ disabled: boolean }>`
  ${({ theme, disabled }) => css`
    position: relative;
    cursor: pointer;
    ${disabled && 'pointer-events:none;'}
    ${TextStyled} {
      position: absolute;
      top: ${theme.spacings[400]};
      left: ${theme.spacings[400]};
      padding: ${theme.spacings[100]};
      background-color: ${theme.colors.white};
      border-radius: ${theme.spacings[300]};
    }
  `}
`;

export const TotalValueContainerStyled = styled(Box).attrs({
  flexGrow: { sm: 1 },
})`
  padding-left: ${headerColumnWidth};
`;
